import React from 'react'

function Footer() {

    return (
        <div>
            <a href="http://www.sabrinalewis.me">
                <h1 className="copyright">(c) 2020  Sabrina  Lewis</h1></a>
        </div>
    )
}

export default Footer;